import React from 'react'
import { Button } from 'antd'
import useTrainingsAdminStore from 'widgets/trainingsListAdmin/TrainingsList/zustand/store'
import './CourseTypeTabs.scss'

const COURSE_TYPES = [
	{ value: 'all', label: 'Все' },
	{ value: 'big', label: 'Большие' },
	{ value: 'mini', label: 'Мини' },
	{ value: 'podcast', label: 'Подкасты' },
	{ value: 'jokes', label: 'Шутки' },
	{ value: 'pronunciation', label: 'Произношение' },
	{ value: 'gramma', label: 'Грамматика' },
	{ value: 'none', label: 'Без типа' },
]

const CourseTypeTabs: React.FC = () => {
	const selectedType = useTrainingsAdminStore((s) => s.selectedType)
	const setSelectedType = useTrainingsAdminStore((s) => s.setSelectedType)

	return (
		<div
			className="course-type-tabs"
			role="tablist"
			aria-label="Фильтр по типу курса"
		>
			{COURSE_TYPES.map((type) => (
				<Button
					key={type.value}
					type={selectedType === type.value ? 'primary' : 'default'}
					size="middle"
					onClick={() => setSelectedType(type.value)}
					aria-label={`Показать курсы типа: ${type.label}`}
					tabIndex={0}
					role="tab"
					aria-selected={selectedType === type.value}
					style={{ marginRight: 8, marginBottom: 8 }}
				>
					{type.label}
				</Button>
			))}
		</div>
	)
}

export default CourseTypeTabs
